import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import elementUi from 'element-ui'
import localeEn from 'element-ui/lib/locale/lang/en'
import localeCn from 'element-ui/lib/locale/lang/zh-CN'
import utils from 'utils/tools'
import VueWechatTitle from 'vue-wechat-title';
import 'element-ui/lib/theme-chalk/index.css'
import './permission'
import 'styles/index.scss'
import VueClipboards from 'vue-clipboards';
import i18n from './i18n';
import VueLazyload from 'vue-lazyload'
import VueTouch from 'vue-touch'

Vue.use(VueLazyload, {
  error: require('static/lazy-load.png'),
  loading: require('static/lazy-load.png')
})
if (store.state.app.language === 'cn') {
  Vue.use(elementUi, {
    localeCn
  })
} else {
  Vue.use(elementUi, {
    localeEn
  })
}

Vue.use(VueTouch, {name: 'v-touch'})
Vue.use(VueWechatTitle)
Vue.prototype.$utils = utils
Vue.config.productionTip = false
Vue.use(VueClipboards);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  template: '<App/>',
  render: (createElement) => createElement(App)
})


// WEBPACK FOOTER //
// ./src/main.js